import React, { useContext } from 'react';
import { AppBar, Toolbar, Typography, IconButton, Box } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import SearchIcon from '@mui/icons-material/Search';

import authContext from '../../context/authentication/authContext';

function NavbarTop() {
    const aContext = useContext(authContext);
    const { usuario, cerrarSesion } = aContext;

    const handleLogout = () => {
        cerrarSesion();
        window.location.replace('/');
    };

    return (
        <AppBar position="static" sx={{ backgroundColor: '#3d4d87' }}>
            <Toolbar>
                <SearchIcon sx={{ mr: 1 }} />
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    XertuX Discover
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Typography variant="body1">
                        {usuario?.fullName}
                    </Typography>
                    <IconButton color="inherit" onClick={handleLogout}>
                        <LogoutIcon />
                    </IconButton>
                </Box>
            </Toolbar>
        </AppBar>
    );
}

export default NavbarTop;
